<template>
  <div>
    <UiInputRadio
      v-model="type"
      :options="radioOptions"
      class="mb-3"
    />

    <TokenAttributePicker
      v-model="localValue"
      :inline-dropdown="true"
      picker-class="flex flex-col gap-3"
    />
  </div>
</template>

<script setup>

import {
  toRefs, ref, computed, watch,
} from 'vue';
import UiInputRadio from '../ui/UiInputRadio.vue';
import TokenAttributePicker from '../TokenAttributePicker.vue';

const props = defineProps(['modelValue']);
const {
  modelValue,
} = toRefs(props);
const emit = defineEmits(['update:modelValue']);

const validate = (value) => value?.length > 0;

const type = ref(modelValue.value?.comparator || 'eq');
const localValue = ref(modelValue.value?.value || null);

watch(modelValue, (v) => {
  type.value = v.comparator;
  localValue.value = v.value;
}, { deep: true });

const radioOptions = computed(() => [
  {
    text: 'Includes',
    value: 'includes',
  },
  {
    text: 'Excludes',
    value: 'excludes',
  },
]);

watch([type, localValue], ([t, v]) => {
  emit('update:modelValue', { comparator: t, value: validate(v) ? v : null });
}, { deep: true });

</script>
